import { HTTPError } from "ky";
import { isErrorEnvelope } from "@/lib/handle-form-error";

interface SearchFailureProps {
  error?: unknown;
  onRetry?: () => void;
  isRetrying?: boolean;
}

export function SearchFailure({ error, onRetry, isRetrying }: SearchFailureProps) {
  const validationError = error instanceof HTTPError && error.response.status === 422;
  const message = validationError
    ? isErrorEnvelope(error.data)
      ? (error.data.errors[0]?.message ?? "Check your search filters and try again.")
      : "Check your search filters and try again."
    : "Search is temporarily unavailable. Try again.";

  return (
    <div role="alert" className="space-y-3 text-center text-[16px]">
      <p className="text-danger">{message}</p>
      {!validationError && onRetry && (
        <button
          type="button"
          onClick={onRetry}
          disabled={isRetrying}
          className="rounded-pill bg-electric-700 px-5 py-2 text-[14px] font-semibold text-white transition-colors hover:bg-electric-800 disabled:opacity-50"
        >
          {isRetrying ? "Trying again…" : "Try again"}
        </button>
      )}
    </div>
  );
}
